<template>
  <CSidebar
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img class="icon" alt="Aeru_logo" src="../assets/icons/logo.png" width="100">
    </CSidebarBrand>
    <CRenderFunction  v-if='partner.role == "admin"' flat :content-to-render="$options.nav"/>

    <CRenderFunction v-else flat :content-to-render="$options.partner_nav"/>
  </CSidebar>
</template>

<script>
import nav from './_nav'
import partner_nav from './_partner_nav'
import { mapGetters } from 'vuex';

export default {
  name: 'TheSidebar',
  nav,
  partner_nav,
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
    ...mapGetters({
      partner:'GetPartner',
    })
  },
}
</script>
